import CompanyInfo from "@/pages/medewerkers/$userId/zakelijke_gegevens/CompanyInfo"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/medewerkers/$userId/zakelijke_gegevens/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "employees"),
})

function RouteComponent() {
  const { userId } = useParams({ from: "/beheer/medewerkers/$userId" })

  return <CompanyInfo userId={Number(userId)} pageType="user_detail" />
}
